export const ExpandTextIcon = ({ isExpanded }: { isExpanded: boolean }) => <svg
  width="19"
  height="19"
  viewBox="0 0 19 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style={{
    transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
    transition: "transform 0.2s ease-in-out",
  }}
>
  <path
    d="M6.10205 8.45166L9.85205 12.2017"
    stroke="#647DAF"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M9.85205 12.2017L13.6021 8.45166"
    stroke="#647DAF"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>